import { directoryTypes } from './directoryTypes';

// The report tabs are the same `reports` endpoint, told apart by these filters. Used for listing and searching.
const reportTabParameters = {
	[directoryTypes.reportPinned]: { is_favorite: 'true', is_disabled: 'false' },
	[directoryTypes.reportScheduled]: { is_scheduled: 'true', is_disabled: 'false' },
	[directoryTypes.reportDisabled]: { is_disabled: 'true' },
};

export default function getEndpointParameters({ directoryType }) {
	switch (directoryType) {
	case directoryTypes.formula: {
		return {
			only_formulas: 'true',
			extended: 'true'
		};
	}
	case directoryTypes.employee:
	case directoryTypes.dataSource: {
		return {
			extended: 'true'
		};
	}
	case directoryTypes.employeeInactive:
		return { extended: 'true', is_active: 'false', action_status__isnull: 'true' };
	case directoryTypes.employeePending:
		return { extended: 'true', is_active: 'false', action_status: 'pending_activation' };
	case directoryTypes.employeeTracked:
		return { extended: 'true', filter_tracked: 'current' };
	case directoryTypes.report:
		// archived reports live in their own tab, so keep them out of the main list
		return { is_disabled: 'false' };
	case directoryTypes.reportPinned:
	case directoryTypes.reportScheduled:
	case directoryTypes.reportDisabled:
		return reportTabParameters[directoryType];
	default:
		return {};
	}
}

export function getSearchQueryParametersByType({ directoryType }) {
	switch (directoryType) {
	case directoryTypes.employee:
		return { extended: 'true' };
	case directoryTypes.employeeInactive:
		return { extended: 'true', is_active: 'false', action_status__isnull: 'true' };
	case directoryTypes.employeePending:
		return { extended: 'true', is_active: 'false', action_status: 'pending_activation' };
	case directoryTypes.employeeTracked:
		return { extended: 'true', filter_tracked: 'current' };
	case directoryTypes.reportPinned:
	case directoryTypes.reportScheduled:
	case directoryTypes.reportDisabled:
		return reportTabParameters[directoryType];
	}
	return {};
}

export function getFilterBy({ directoryType }, filterBy = {}) {
	switch (directoryType) {
	case directoryTypes.employee:
	case directoryTypes.employeeInactive:
	case directoryTypes.employeePending:
	case directoryTypes.employeeTracked: {
		return filterBy;
	}

	default:
		return {};
	}
}

export function getOrderBy({ directoryType }, orderBy) {
	switch (directoryType) {
	case directoryTypes.employee:
	case directoryTypes.employeeInactive:
	case directoryTypes.employeePending:
	case directoryTypes.employeeTracked: {
		if (!orderBy?.length) {
			return {};
		}
		const order = orderBy[0];
		const directionSign = order.direction === 'desc' ? '-' : '';
		if (order.field === 'real_name') {
			return {
				order_by: `${directionSign}real_name`,
			};
		} else {
			return {
				order_by: `${directionSign}${order.field},real_name`,
			};
		}
	}

	default:
		return {};
	}
}
